export const getNumberInsideFrame =
  (start: number, end: number) =>
  (number: number): number => {
    if (number < start) return start
    if (number > end) return end
    return number
  }

export const isNumberInsideFrame =
  (start: number, end: number) =>
  (number: number): boolean => {
    return number >= start && number <= end
  }
